import { atom } from 'jotai';
import {
  getTicketsList,
  getTicketAliasFromPathname,
  getStaticData,
} from 'utils';

export const cookiesAtom = atom(false);

export const displayCookiesAtom = atom(false);
export const displayClearCookiesAtom = atom(false);
export const cookiesDeletedAtom = atom(false);

export const listTicketsAtom = atom(async (get) => {
  const { idSession } = get(staticDataAtom);
  const tickets = await getTicketsList(idSession);
  return tickets;
});
/**
 * static data (currency, idSessionBrowser, nameRestaurant)
 */
export const staticDataAtom = atom(async (get) => {
  const init = {
    currency: {
      countryCode: 'fr-FR',
      labelCode: 'EUR',
      symbol: '€',
    },
    company: {
      name: '',
      siret: '',
    },
    idSession: null,
    askCookies: true,
    tips: [],
  };

  const pathname = window?.location?.pathname;
  const ticketAlias = getTicketAliasFromPathname(pathname);
  const staticTicketData = await getStaticData(ticketAlias, init);
  return staticTicketData?.idSession ? staticTicketData : init;
});
